import React from 'react';

interface VenereCalendarProps {
  size?: number;
  className?: string;
  color?: string;
  onClick?: () => void;
}

export const VenereCalendar: React.FC<VenereCalendarProps> = ({
  size = 24,
  className = '',
  color = 'currentColor',
  onClick,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 2000 2000"
      fill={color}
      className={className}
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
    >
      <path d="M1584.53,362.34h-159.42v-53.14c0-29.36-23.78-53.14-53.14-53.14s-53.14,23.78-53.14,53.14v53.14h-637.66v-53.14c0-29.36-23.78-53.14-53.14-53.14s-53.14,23.78-53.14,53.14v53.14h-159.42c-87.88,0-159.42,71.54-159.42,159.42v1062.77c0,87.88,71.54,159.42,159.42,159.42h159.42c29.36,0,53.14-23.78,53.14-53.14s-23.78-53.14-53.14-53.14h-159.42c-29.29,0-53.14-23.85-53.14-53.14v-797.08h1275.33v797.08c0,29.29-23.85,53.14-53.14,53.14h-797.08c-29.36,0-53.14,23.78-53.14,53.14s23.78,53.14,53.14,53.14h797.08c87.88,0,159.42-71.54,159.42-159.42V521.75c0-87.88-71.54-159.42-159.42-159.42ZM1637.67,681.17H362.33v-159.42c0-29.29,23.84-53.14,53.14-53.14h159.42v53.14c0,29.36,23.78,53.14,53.14,53.14s53.14-23.78,53.14-53.14v-53.14h637.66v53.14c0,29.36,23.78,53.14,53.14,53.14s53.14-23.78,53.14-53.14v-53.14h159.42c29.29,0,53.14,23.85,53.14,53.14v159.42Z"/>
      <path d="M1000,927.56c-31.7,0-57.4,25.7-57.4,57.4v165.71h-165.71c-31.7,0-57.4,25.7-57.4,57.4s25.69,57.4,57.4,57.4h165.71v165.71c0,31.7,25.69,57.4,57.4,57.4s57.4-25.7,57.4-57.4v-165.71h165.71c31.7,0,57.4-25.7,57.4-57.4s-25.69-57.4-57.4-57.4h-165.71v-165.71c0-31.7-25.69-57.4-57.4-57.4Z"/>
    </svg>
  );
};

export default VenereCalendar; 